module.exports = __webpack_public_path__ + "img/blog-46.1f56ef27.jpg";